export default __webpack_public_path__ + "static/N0221-505f6f25d7e1ac5adb8a21fb908e0ea5.png";